// =====================
// PARALLAX BACKGROUND
// =====================
document.addEventListener("scroll", () => {
  const section = document.querySelector(".collection-tabs--bg");
  if (!section) return;

  // Liquid value injected from schema
  const strength = 4;
  const offset = window.scrollY / strength;

  section.style.backgroundPosition = `center calc(50% + ${offset}px)`;
});


// ==========================
// FLOATING CARDS ANIMATION
// ==========================
function floatingCardsAnimation(selector, intensity = 6, speed = 1500) {
  const cards = document.querySelectorAll(selector);
  if (!cards.length) return;

  cards.forEach((card, i) => {
    let direction = 1;

    function animate() {
      card.style.transform = `translateY(${direction * intensity}px)`;
      card.style.transition = `transform ${speed}ms ease-in-out`;

      direction *= -1;

      setTimeout(animate, speed);
    }

    // natural stagger so they don't move in sync
    setTimeout(animate, i * 200);
  });
}

// INIT floating animation after DOM is loaded
document.addEventListener("DOMContentLoaded", () => {
  floatingCardsAnimation(".collection-tab__products .f-column");
});
